module.exports = __webpack_public_path__ + "img/71ne.df7fcc91.svg";